module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step03-9f76862a1d2df2d4193b5167cfc3931b.jpg";